import { Drawer } from 'palette/Drawer';
import BurgerNavContent from '@common/BurgerNavigation/BurgerNavContent';
import { Spinner } from '@common/Spinner';
import { parseJSON } from '@helpers/data';
import './styles/BurgerNavigation.scss';

export function BurgerNavigation({
    uuids,
    tabIds,
    unisexTabIds,
    imagesSourceUrl,
    customerServicePageUuids,
    languages,
    toggleMenu,
    modalId,
    navigation,
    serviceSection,
    menuItems,
    breadcrumbs,
    setSelectedDepartment,
    selectedDepartment
}) {
    return (
        <Drawer id={modalId}>
            {navigation
                ? (
                    <BurgerNavContent
                        breadcrumbs={breadcrumbs}
                        customerServicePageUuids={customerServicePageUuids}
                        imagesSourceUrl={imagesSourceUrl}
                        languages={languages}
                        menuItems={menuItems}
                        navigation={navigation}
                        selectedDepartment={selectedDepartment}
                        serviceSection={serviceSection}
                        setIsNavOpen={toggleMenu}
                        setSelectedDepartment={setSelectedDepartment}
                        tabIds={tabIds}
                        unisexTabIds={unisexTabIds}
                        uuids={uuids !== undefined && parseJSON(uuids)}
                    />
                )
                : <Spinner />}
        </Drawer>
    );
}
